import { on } from 'delegated-events'
import scrollTo from '@common/scroll-to'

on('click', '[data-team-filter]', (e) => {
  const filter = e.target.closest('[data-team-filter]')
  const panels = document.querySelectorAll('[data-team-panel]')
  const target = filter.dataset.teamFilter
  const panel = document.querySelector(`[data-team-panel="${target}"]`)

  document.querySelectorAll('[data-team-filter]').forEach((x) => x.classList.remove('is-active'))
  filter.classList.add('is-active')

  if (target === 'all') {
    panels.forEach((x) => x.classList.remove('hidden'))
    scrollTo(document.body)
  } else {
    panels.forEach((x) => x.classList.add('hidden'))
    panel.classList.remove('hidden')
    scrollTo(panel)
  }
})
